// Generado por scripts/gen-version.mjs. No editar ni versionar.
export const APP_VERSION = {
  "version": "1.27.0",
  "build": "fa193e28",
  "env": "production",
  "builtAt": "2026-11-05T03:57:49.966Z"
} as { version: string; build: string; env: string; builtAt: string };
